
import { mapState } from "vuex";

export default {
  props: {
    name: { type: String, required: true },
  },

  computed: {
    ...mapState("bedbuilder", [
      "activeOption",
      "activeOptions",
      "availableOptions",
    ]),
  },

  methods: {
    handleCancel() {
      this.$store.dispatch("bedbuilder/closeBedbuilderOptionsChange");
    },
    handleChangeOptions() {
      const updatedOptions = {
        ...this.activeOptions,
        [this.activeOption]: this.name,
      };

      if (this.activeOption === "Material") {
        updatedOptions.Colour =
          Object.keys(this.availableOptions[this.name] || {})[0] || "";
      }

      if (this.activeOption === "Material" || this.activeOption === "Colour") {
        const selected =
          this.availableOptions[updatedOptions.Material]?.[
            updatedOptions.Colour
          ] || {};
        updatedOptions.Base = [...selected.Base]?.[0] || "";
        updatedOptions.Headboard = [...selected.Headboard]?.[0] || "";
      }

      this.$router.push({
        path: this.$route.path,
        query: updatedOptions,
      });

      this.$store.dispatch("bedbuilder/closeBedbuilderOptionsChange");
    },
  },
};
